export default __webpack_public_path__ + "static/media/Gallery77.b12828ef.png";